























































































import Vue from "vue";
import storeHelper from "../store/store-helper";
import _ from "lodash";
import { ContentItemsRequest } from "../types/ContentItemsRequest";
import FillOutContentItemsList from "../components/contentItemsList/FillOutContentItemsList.vue";
import { Sort, ContentItem, Portal } from "@infoland/iprova-api";
import SearchComponent from "../components/generic/SearchComponent.vue";
import { PortalSearchOptions } from "@/types/portal";
import NavDrawerContentItemDetails from "../components/navigation-drawer/NavDrawerContentItemDetails.vue";
import Toolbar from "../components/toolbar/Toolbar.vue";
import { ContentListItem } from "@/types/contentListItem";
import Utils from "@/utils";
import { getPortalForUserWithRedirectAsync } from "@/portals";
import { ApiErrorType } from "@/enums";
import Alert from "../components/alerts/alert.vue";
import { Category } from "@/store/modules/site";

export default Vue.extend({
    name: "FillOut",
    components: { FillOutContentItemsList, SearchComponent, NavDrawerContentItemDetails, Toolbar, Alert },
    props: {
        portalId: Number,
        searchText: String
    },
    data: () => {
        return {
            loadingInProgress: false,
            loadedFillOutContentItems: [] as ContentItem[],
            fillOutCategories: null as Category[],
            currentItem: null,
            drawerRight: false,
            searchSuggestionCorrection: null,
            portal: null as Portal,
            errorType: null as ApiErrorType,
            showError: null as Boolean
        };
    },
    computed: {
        changedProps(): Object {
            return { portalId: this.portalId, searchText: this.searchText };
        },
        mdAndDown(): boolean {
            return this.$vuetify.breakpoint.mdAndDown;
        },
        showIdentifierInTitle(): boolean {
            return this.portal?.show_identifier;
        },
        loadedFilledOutContentItemList(): ContentItem[] {
            return this.loadedFillOutContentItems;
        }
    },
    created() {
        storeHelper.contentItemsStore.setIncludeSearchSuggestionCorrection(false);
    },
    beforeRouteEnter(to, from, next) {
        if (from?.name == "Portal") {
            storeHelper.contentItemsStore.reset();
        }
        next();
    },
    watch: {
        changedProps: {
            async handler(newValue: Object) {
                this.loadedFillOutContentItems = [];
                this.drawerRight = false;
                const result = await getPortalForUserWithRedirectAsync(this.portalId, this.$user.user_id, window.location.href);
                this.portal = result.portal;
                this.errorType = result.errorType;
                this.showError = result.showError;
                if (this.portal) {
                    await this.loadFillOutContentItems();
                }
            },
            immediate: true
        }
    },
    methods: {
        async loadFillOutContentItems() {
            if (this.loadingInProgress) return;
            this.loadingInProgress = true;

            this.fillOutCategories = await storeHelper.siteStore.getCategoriesAsync();

            const results: ContentItem[] = await storeHelper.contentItemsStore.loadFillOutContentItemsAsync(
                this.searchText,
                this.portalId,
                100,
                this.loadedFillOutContentItems.length
            );
            if (results != null && results.length > 0) {
                this.loadedFillOutContentItems = this.loadedFillOutContentItems == null ? results : this.loadedFillOutContentItems.concat(results);
            }

            this.searchSuggestionCorrection = storeHelper.contentItemsStore.searchSuggestionCorrection;
            this.loadingInProgress = false;
        },
        async onUseSearchSuggestedCorrection() {
            storeHelper.contentItemsStore.setIncludeSearchSuggestionCorrection(false);
            await this.doSearch({ text: this.searchSuggestionCorrection, scope: "portal" });
        },
        shouldStillLoadData(): boolean {
            return this.loadedFillOutContentItems.length < storeHelper.contentItemsStore.totalNumberOffillOutContentItem;
        },
        async loadContentItemsOnScroll() {
            if (this.shouldStillLoadData()) {
                await this.loadFillOutContentItems();
            }
        },

        async onTextBoxSearch(options: PortalSearchOptions) {
            let includeSearchSuggestionCorrection = options.text ? true : false;
            storeHelper.contentItemsStore.setIncludeSearchSuggestionCorrection(includeSearchSuggestionCorrection);
            await this.doSearch(options);
        },

        async doSearch(options: PortalSearchOptions) {
            //prevent change to same route
            if (this.searchText !== options.text)
                this.$router.replace({
                    query: { searchText: options.text }
                });
            return;
        },
        async getAutoCompleteItems(val: string) {
            return await storeHelper.suggestionsStore.getSearchSuggestions(this.portalId, val);
        },
        openContentItemDetails(item) {
            this.currentItem = item;
            this.drawerRight = true;
        },
        closeDrawerRight() {
            this.drawerRight = false;
        },
        itemClicked(item: ContentListItem): void {
            const currentItem = this.loadedFillOutContentItems.find(rci => rci.content_item_id == item.content_item_id);
            Utils.openContentItem(currentItem, this.$router, this.portalId);
        }
    }
});
